import FeedbackOutlinedIcon from "@mui/icons-material/FeedbackOutlined";
import cx from "classnames";
import FeedbackDialog from "src/components/general/FeedbackDialog/FeedbackDialog";
import { SCREENSHOT_EXCLUDE_ATTR } from "src/components/general/FeedbackDialog/FeedbackDialog.constants";
import FabButtonPanel from "./components/FabButtonPanel/FabButtonPanel";
import FabButtonTrigger from "./components/FabButtonTrigger/FabButtonTrigger";
import { useFabButton } from "./FabButton.hooks";

const FabButton = () => {
  const {
    isHidden,
    open,
    isCompact,
    fabSize,
    rows,
    feedbackOpen,
    closeFeedback,
    onTriggerClick,
    handleOnMouseDownCapture,
  } = useFabButton();

  // E2E builds set VITE_PLAYWRIGHT_TEST — hide FAB to avoid flaky screenshots.
  if (isHidden || import.meta.env.VITE_PLAYWRIGHT_TEST === "true") {
    return null;
  }

  return (
    <>
      <div
        {...{ [SCREENSHOT_EXCLUDE_ATTR]: "" }}
        className={cx(
          `group/fab pointer-events-none fixed z-max
          translate-y-0 filter-[drop-shadow(0_10px_25px_rgb(0_0_0/0.45))]
          transition-transform delay-[1.5s] duration-700 easing-spring starting:translate-y-24
          motion-reduce:delay-0 motion-reduce:transition-none`,
          isCompact ? "bottom-1 right-1" : "bottom-3 right-3"
        )}
      >
        <FabButtonPanel
          open={open}
          fabSize={fabSize}
          rows={rows}
          onMouseDownCapture={handleOnMouseDownCapture}
        />
        <FabButtonTrigger
          open={open}
          onClick={onTriggerClick}
          size={fabSize}
          tooltip="Help us improve. Give a feedback"
        >
          <FeedbackOutlinedIcon fontSize={isCompact ? "small" : "large"} />
        </FabButtonTrigger>
      </div>
      <FeedbackDialog open={feedbackOpen} onClose={closeFeedback} />
    </>
  );
};

export default FabButton;
